var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrollPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Enroll") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "enrollICP",
    d: "M0,0v67h30.875c11.667,0,21.125-9.2847,21.125-20.7381V0H0ZM48.75,46.2619c0,9.6913-8.0029,17.5476-17.875,17.5476H3.25V3.1905h45.5v43.0714Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "enrollICP",
    x: 14.625,
    y: 44.6667,
    width: 16.25,
    height: 3.1905
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "enrollICP",
    x: 14.625,
    y: 31.9048,
    width: 22.75,
    height: 3.1905
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "enrollICP",
    x: 14.625,
    y: 19.1429,
    width: 22.75,
    height: 3.1905
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollPaper);
export default __webpack_public_path__ + "static/media/enroll-paper.f39555f0a09cb1419ca40b55b961e0fc.svg";
export { ForwardRef as ReactComponent };